import type { ReactNode } from "react";

// Only http(s) URLs are linkified (no javascript:/data: schemes) and React builds
// the <a> nodes, so text stays XSS-safe — never use dangerouslySetInnerHTML.
const URL_RE = /(https?:\/\/[^\s]+)/g;

export function linkify(text: string): ReactNode {
  return text.split(URL_RE).map((part, i) => {
    if (i % 2 === 0) return part; // even segments are plain text
    const trail = part.match(/[.,!?;:)\]]+$/)?.[0] ?? ""; // keep trailing punctuation out of the link
    const url = trail ? part.slice(0, -trail.length) : part;
    return (
      <span key={i}>
        {/* stopPropagation so tapping a link doesn't also fire a parent onClick (e.g. list photo modal) */}
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{url}</a>
        {trail}
      </span>
    );
  });
}
